import React from 'react'
import {
  AreaSearch,
  Bicycle,
  BrainResearch,
  CoinsSwap,
  Compass,
  DocStarIn,
  Golf,
  MagicWand,
  QuoteMessage,
} from 'iconoir-react'
import {
  BookmarkIcon,
  CheckIcon,
  ClipboardDocumentListIcon,
  ComputerDesktopIcon,
  DocumentTextIcon,
  HeartIcon,
  LightBulbIcon,
  PlusIcon,
  PuzzlePieceIcon,
  SpeakerWaveIcon,
  TrashIcon,
  UserIcon,
  VideoCameraIcon,
  WrenchIcon,
  WrenchScrewdriverIcon,
  XMarkIcon,
  BuildingStorefrontIcon,
  SparklesIcon,
  AcademicCapIcon,
  ChatBubbleLeftRightIcon,
  BriefcaseIcon,
  BookOpenIcon,
  RocketLaunchIcon,
  MapIcon,
  Cog6ToothIcon,
  Squares2X2Icon,
  ChatBubbleBottomCenterTextIcon,
  UserCircleIcon,
  UserGroupIcon,
  UsersIcon,
} from '@heroicons/react/24/outline'

const RetirementIcon = ({ className = '', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      width="24"
      height="24"
      viewBox="0 -11.95 122.88 122.88"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M37.71,39.99V93.4h5.48l7.22-7.94h-3.83v-4.85h11.86L45.06,65.78l3.6-3.24l8.1,8.97v-0.35h19.83 c0.87,0,1.64,0.46,2.07,1.15l5.86,8.29h11.01c0.73,0,1.39,0.32,1.83,0.84l12.06,11.96h13.46v5.57H0.7V93.4h31.8V39.99H1.89 C0.85,39.99,0,39.15,0,38.1c0-0.06,0-0.12,0.01-0.19c0.08-9.42,4.01-17.93,10.32-24.1C16.56,7.74,25.1,3.93,34.54,3.8 c0.18-0.06,0.38-0.09,0.58-0.09c0.2,0,0.4,0.03,0.59,0.09c9.39,0.17,17.87,3.97,24.07,10.02c6.35,6.21,10.29,14.79,10.32,24.28 c0,1.04-0.84,1.88-1.88,1.88v0.01H37.71L37.71,39.99L37.71,39.99z M91.48,4.24c-0.35-0.6-0.14-1.38,0.46-1.73 c0.6-0.35,1.38-0.15,1.73,0.46l1.62,2.81c0.35,0.6,0.14,1.38-0.46,1.73c-0.6,0.35-1.38,0.14-1.72-0.46L91.48,4.24L91.48,4.24 L91.48,4.24z M101.56,8.4c3.12,0,5.95,1.26,7.99,3.31c2.04,2.04,3.31,4.87,3.31,7.99c0,3.12-1.26,5.94-3.31,7.99 c-2.04,2.05-4.87,3.31-7.99,3.31c-3.12,0-5.94-1.26-7.99-3.31c-2.04-2.04-3.31-4.87-3.31-7.99s1.26-5.94,3.31-7.99 C95.62,9.67,98.45,8.4,101.56,8.4L101.56,8.4L101.56,8.4z M100.56,1.27c0-0.7,0.57-1.27,1.27-1.27s1.27,0.57,1.27,1.27v3.24 c0,0.7-0.57,1.27-1.27,1.27s-1.27-0.57-1.27-1.27V1.27L100.56,1.27L100.56,1.27z M109.92,3.24c0.35-0.6,1.12-0.81,1.72-0.46 c0.6,0.35,0.81,1.12,0.46,1.72l-1.62,2.81c-0.35,0.6-1.12,0.81-1.72,0.47c-0.6-0.35-0.81-1.12-0.46-1.72L109.92,3.24L109.92,3.24 L109.92,3.24z M117.03,9.62c0.6-0.35,1.38-0.14,1.72,0.46s0.14,1.38-0.46,1.73l-2.8,1.62c-0.6,0.35-1.38,0.14-1.73-0.46 c-0.35-0.6-0.14-1.38,0.46-1.73L117.03,9.62L117.03,9.62L117.03,9.62z M120,18.69c0.7,0,1.27,0.57,1.27,1.27 c0,0.7-0.57,1.27-1.27,1.27h-3.24c-0.7,0-1.27-0.57-1.27-1.27c0-0.7,0.57-1.27,1.27-1.27H120L120,18.69L120,18.69z M118.03,28.05 c0.6,0.35,0.81,1.12,0.46,1.72c-0.35,0.6-1.12,0.81-1.72,0.46l-2.81-1.62c-0.6-0.35-0.81-1.12-0.46-1.72 c0.35-0.6,1.12-0.81,1.72-0.46L118.03,28.05L118.03,28.05L118.03,28.05z M111.65,35.16c0.35,0.6,0.14,1.38-0.46,1.73 c-0.6,0.35-1.38,0.15-1.72-0.46l-1.62-2.81c-0.35-0.6-0.14-1.38,0.46-1.73c0.6-0.35,1.38-0.14,1.73,0.46L111.65,35.16L111.65,35.16 L111.65,35.16z M102.57,38.13c0,0.7-0.57,1.27-1.27,1.27c-0.7,0-1.26-0.57-1.26-1.27v-3.24c0-0.7,0.57-1.27,1.26-1.27 c0.7,0,1.27,0.57,1.27,1.27V38.13L102.57,38.13L102.57,38.13z M93.21,36.16c-0.35,0.6-1.12,0.81-1.72,0.46 c-0.6-0.35-0.81-1.12-0.46-1.72l1.62-2.81c0.35-0.6,1.12-0.81,1.72-0.47c0.6,0.35,0.81,1.12,0.46,1.72L93.21,36.16L93.21,36.16 L93.21,36.16z M86.1,29.78c-0.6,0.35-1.38,0.14-1.73-0.46c-0.35-0.6-0.14-1.38,0.46-1.73l2.81-1.62c0.6-0.35,1.38-0.14,1.72,0.46 c0.35,0.6,0.14,1.38-0.46,1.73L86.1,29.78L86.1,29.78L86.1,29.78z M83.13,20.7c-0.7,0-1.27-0.57-1.27-1.27 c0-0.7,0.57-1.27,1.27-1.27h3.24c0.7,0,1.27,0.57,1.27,1.27c0,0.7-0.57,1.27-1.27,1.27H83.13L83.13,20.7L83.13,20.7z M85.1,11.35 c-0.6-0.35-0.81-1.12-0.46-1.72c0.35-0.6,1.12-0.81,1.72-0.46l2.81,1.62c0.6,0.35,0.81,1.12,0.46,1.72 c-0.35,0.6-1.12,0.81-1.72,0.46L85.1,11.35L85.1,11.35L85.1,11.35z M49.74,93.41h52.8l-8.01-7.94H56.96L49.74,93.41L49.74,93.41 L49.74,93.41z M64.97,80.61h13.61l-3.24-4.59H60.83L64.97,80.61L64.97,80.61L64.97,80.61z M57.15,16.52 c-2.56-2.5-5.57-4.58-8.89-6.09c1.28,1.85,2.36,3.96,3.24,6.29c2.05,5.41,3.05,12.06,3.15,19.5h11.62 C65.77,28.54,62.38,21.63,57.15,16.52L57.15,16.52L57.15,16.52z M40.58,8.05c-1.17-0.2-2.36-0.34-3.57-0.42v28.59h13.88 c-0.09-6.98-1.02-13.18-2.91-18.17C46.3,13.6,43.86,10.15,40.58,8.05L40.58,8.05L40.58,8.05z M33.23,7.62 c-1.19,0.07-2.37,0.2-3.52,0.39c-3.32,2.11-5.79,5.59-7.48,10.1c-1.87,4.97-2.79,11.16-2.88,18.1l13.88,0V7.62L33.23,7.62 L33.23,7.62z M22.05,10.34c-3.4,1.53-6.48,3.63-9.09,6.19c-5.23,5.11-8.62,12.02-9.12,19.69H15.6c0.09-7.4,1.09-14.03,3.12-19.43 C19.61,14.39,20.72,12.22,22.05,10.34L22.05,10.34L22.05,10.34z"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const WellnessIcon = ({ className = '', ...props }) => {
  return (
    <svg
      className={className}
      role="img"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <title>wellness</title>
      <path
        d="M18 20L21.8243 16.1757C21.9368 16.0632 22 15.9106 22 15.7515V10.5C22 9.67157 21.3284 9 20.5 9C19.6716 9 19 9.67157 19 10.5V15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 16L18.8581 15.1419C18.949 15.051 19 14.9278 19 14.7994C19 14.6159 18.8963 14.4482 18.7322 14.3661L18.2893 14.1447C17.5194 13.7597 16.5894 13.9106 15.9807 14.5193L15.0858 15.4142C14.7107 15.7893 14.5 16.298 14.5 16.8284V20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 20L2.17574 16.1757C2.06321 16.0632 2 15.9106 2 15.7515V10.5C2 9.67157 2.67157 9 3.5 9C4.32843 9 5 9.67157 5 10.5V15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 16L5.14187 15.1419C5.05103 15.051 5 14.9278 5 14.7994C5 14.6159 5.10366 14.4482 5.26776 14.3661L5.71067 14.1447C6.48064 13.7597 7.41059 13.9106 8.01931 14.5193L8.91421 15.4142C9.28929 15.7893 9.5 16.298 9.5 16.8284V20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6667 12H10.3333V9.66667H8V6.33333H10.3333V4H13.6667V6.33333H16V9.66667H13.6667V12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Map of display names to icon components
const iconMap = {
  add: PlusIcon,
  alya: MagicWand,
  article: Compass,
  assessment: BrainResearch,
  audio: SpeakerWaveIcon,
  bookmark: BookmarkIcon,
  builder: WrenchScrewdriverIcon,
  checklist: ClipboardDocumentListIcon,
  'coach-insights': DocStarIn,
  'coach-notes': ChatBubbleBottomCenterTextIcon,
  'coach-services': UserIcon,
  'coach-services-circle': UserCircleIcon,
  completed: CheckIcon,
  dashboard: Squares2X2Icon,
  entrepreneurship: BuildingStorefrontIcon,
  exercise: Bicycle,
  heart: HeartIcon,
  interview: ChatBubbleLeftRightIcon,
  'interview-deloitte': UsersIcon,
  'job-targeting': BriefcaseIcon,
  negotiation: CoinsSwap,
  networking: UserGroupIcon,
  'onboarding-success': RocketLaunchIcon,
  orientation: MapIcon,
  'personal-brand': SparklesIcon,
  quiz: PuzzlePieceIcon,
  research: BookOpenIcon,
  retirement: RetirementIcon,
  'sample-doc': DocumentTextIcon,
  scripts: QuoteMessage,
  'search-tools': AreaSearch,
  settings: Cog6ToothIcon,
  'short-course': Golf,
  skills: AcademicCapIcon,
  tips: LightBulbIcon,
  tools: WrenchIcon,
  trash: TrashIcon,
  video: VideoCameraIcon,
  webinar: ComputerDesktopIcon,
  wellness: WellnessIcon,
  x: XMarkIcon,
}

// Export individual icon components
export const Add = PlusIcon
export const Alya = MagicWand
export const Article = Compass
export const Assessment = BrainResearch
export const Audio = SpeakerWaveIcon
export const Bookmark = BookmarkIcon
export const Builder = WrenchScrewdriverIcon
export const Checklist = ClipboardDocumentListIcon
export const CoachInsights = DocStarIn
export const CoachNotes = ChatBubbleBottomCenterTextIcon
export const CoachServices = UserIcon
export const CoachServicesCircle = UserCircleIcon
export const Completed = CheckIcon
export const Dashboard = Squares2X2Icon
export const Entrepreneurship = BuildingStorefrontIcon
export const Exercise = Bicycle
export const Heart = HeartIcon
export const Interview = ChatBubbleLeftRightIcon
export const InterviewDeloitte = UsersIcon
export const JobTargeting = BriefcaseIcon
export const Negotiation = CoinsSwap
export const Networking = UserGroupIcon
export const OnboardingSuccess = RocketLaunchIcon
export const Orientation = MapIcon
export const PersonalBrand = SparklesIcon
export const Quiz = PuzzlePieceIcon
export const Research = BookOpenIcon
export const Retirement = RetirementIcon
export const SampleDoc = DocumentTextIcon
export const Scripts = QuoteMessage
export const SearchTools = AreaSearch
export const Settings = Cog6ToothIcon
export const ShortCourse = Golf
export const Skills = AcademicCapIcon
export const Tips = LightBulbIcon
export const Tools = WrenchIcon
export const Trash = TrashIcon
export const Video = VideoCameraIcon
export const Webinar = ComputerDesktopIcon
export const Wellness = WellnessIcon
export const X = XMarkIcon

function YnsIcon({ name, className = '', size = 24, ...props }) {
  // Convert name to lowercase and handle special characters
  const normalizedName = name.toLowerCase().replace(/\s+/g, '-')
  const IconComponent = iconMap[normalizedName]

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in icon map`)
    return null
  }

  // Check if className already includes width/height classes
  const hasWidthClass = /\bw-\d+\b/.test(className)
  const hasHeightClass = /\bh-\d+\b/.test(className)

  // Add size classes only if they're not already present
  const sizeClasses =
    !hasWidthClass && !hasHeightClass ? `w-[${size}px] h-[${size}px]` : ''
  const finalClassName = `${className} ${sizeClasses}`.trim()

  return <IconComponent className={finalClassName} {...props} />
}

export default YnsIcon
